import {AssetStatus, type IAsset} from '../schema/asset';

const PRESENT_STATUSES = [
	AssetStatus.ONLINE,
	AssetStatus.TEMP,
	AssetStatus.NEARLINE,
	AssetStatus.CHECKOUT,
];

/**
 * This test is cribbed from Flex: it checks the asset.status value to make sure the asset file is actually available on the DAM.
 * @returns Asset is present
 */
export const assetIsPresent = (
	asset?: Pick<IAsset, 'status'>,
): asset is IAsset => !!asset && PRESENT_STATUSES.includes(asset.status);
